import { getBenefit } from '@/services/order';
import { commonLog } from '@/services/app';

const getBenefitMixin = {
  data() {
    return {
      mixinRecommendBenefit: null,
      mixinBenefits: [],
      mixinPopupPayRule: '',
      mixinShouldPay: '',
      showPayPopup: false,
      benefitPopupTargetId: 0,
      benefitPopupTargetType: '',
      benefitPopupTargetTitle: '',
    };
  },
  methods: {
    mixinGetBenefit(id, type) {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await getBenefit(id, type);
          this.benefitPopupTargetId = id;
          this.benefitPopupTargetType = type;
          this.mixinRecommendBenefit = data.recommendBenefit;
          this.mixinPopupPayRule = data.rule;
          const { product = {} } = data;
          this.benefitPopupTargetTitle = product.title || '';
          this.mixinBenefits = data.benefits;
          this.mixinShouldPay = data.shouldPay;
          this.showPayPopup = true;
          return resolve();
        } catch (e) {
          commonLog('getBenefitError', e);
          return reject(e);
        }
      });
    },
  },
};

export default getBenefitMixin;
